import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { IdNameWidgetResponse } from '@app/models/response.model';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgOptimizedImage],
})
export class UserAvatarComponent {
  name = input<string>();
  avatar = input<string>();
  size = input<number>(56);
  fontSize = input<number>();
  radius = input<string>('50%');
  avatars = input<IdNameWidgetResponse[]>();
  nestedAvatarSize = input<number>(21);
  newDesign = input<boolean>(false);

  readonly firstLetterName = computed(() => this.name()?.charAt(0)?.toUpperCase());
  readonly initials = computed<string>(() => {
    const words = this.name()?.trim().split(/\s+/).filter(Boolean) ?? [];

    return words.length > 1
      ? (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
      : (this.firstLetterName() ?? '');
  });
  readonly calculatedFontSize = computed(() => this.size() / 2);

  readonly MAX_AVATARS_LENGTH = 4;
}
